import { useCallback, useEffect, useState } from 'react';
import { SetupModal } from '../components/SetupModal';
import type { ShellCtx } from '../components/Shell';
import { api } from '../lib/api';

export function Settings({ ctx }: { ctx: ShellCtx }) {
  const [settings, setSettings] = useState<Record<string, unknown> | null>(null);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    try {
      const r = await api.getSettings();
      setSettings(r.settings);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to load');
    }
  }, []);

  useEffect(() => {
    void load();
  }, [load]);

  if (error) {
    return (
      <div className="page">
        <div className="error-banner">{error}</div>
      </div>
    );
  }
  if (settings === null) {
    return (
      <div className="page">
        <div className="empty-state">Loading…</div>
      </div>
    );
  }

  return (
    <SetupModal
      initialSettings={settings}
      onClose={() => ctx.navigate({ name: 'overview' })}
      onSaved={(s) => setSettings(s)}
    />
  );
}
